export function productsTrackingSchema(
  hotelId: number,
  pinnedResult: boolean,
  sponsored: boolean,
  packageType?: string,
  brandedDealType?: string
) {
  return packageType
    ? allMultiItemProductsSchema(hotelId, pinnedResult, sponsored, packageType, brandedDealType)
    : allHotelProductsSchema(hotelId, pinnedResult, sponsored);
}

export function allHotelProductsSchema(hotelId: number, pinnedResult: boolean, sponsored: boolean) {
  return [
    {
      messageContent: {
        numOfProducts: 1,
        hotelProducts: [
          {
            deal: {},
            pinned: { pinnedResult },
            productId: hotelId,
            productType: 'HOTELS',
            sponsored,
          },
        ],
      },
      schemaName: 'allHotelProducts',
    },
  ];
}

export function allMultiItemProductsSchema(
  hotelId: number,
  pinnedResult: boolean,
  sponsored: boolean,
  packageType: string,
  brandedDealType?: string
) {
  const brandedDeal = brandedDealType
    ? {
        brandedDeal: {
          displayed: true,
          selectedDeal: brandedDealType,
          availableDeals: [{ dealType: brandedDealType }],
        },
      }
    : {};

  const hotelProduct = allHotelProductsSchema(hotelId, pinnedResult, sponsored)[0].messageContent.hotelProducts[0];
  hotelProduct.deal = {
    ...hotelProduct.deal,
    ...brandedDeal,
  };

  return [
    {
      messageContent: {
        numOfProducts: 1,
        multiItemProducts: [
          {
            multiItemProductType: packageType,
            sortPosition: 1,
            productType: 'PACKAGES',
            products: [
              {
                hotelProduct,
              },
            ],
          },
        ],
      },
      schemaName: 'allMultiItemProducts',
    },
  ];
}

export function allRoomsSchema(category: string, offerType: string, promotionId: number, hotelId: number) {
  return [
    {
      messageContent: {
        numOfProducts: 1,
        hotelProducts: [
          {
            productId: hotelId,
          },
        ],
        rooms: [
          {
            ratePlans: [
              {
                valueAddPromotions: [
                  {
                    category,
                    offerType,
                    promotionId,
                  },
                ],
              },
            ],
          },
        ],
      },
      schemaName: 'allRooms',
    },
  ];
}

export const roomSchema = (
  roomTypeCode: string,
  ratePlans?: any[],
  referenceRoomTypeCode?: string,
  beddingType?: string,
  roomSortPosition?: number,
  displayedAmenities?: any[],
  imageDisplayed?: boolean,
  accessibility?: any,
  displayedSpecialRequestTypes?: string[],
  viewTypeBadge?: any
) => ({
  schemaName: 'room',
  messageContent: {
    roomTypeCode,
    referenceRoomTypeCode,
    beddingType,
    roomSortPosition,
    ratePlans,
    displayedAmenities,
    imageDisplayed,
    accessibility,
    displayedSpecialRequestTypes,
    viewTypeBadge,
  },
});

export const upsellSchema = (
  rateUpsell: boolean,
  additionalAmount: number,
  ratePlanCode: string,
  roomTypeCode: string,
  hotelId: number,
  roomUpsell: boolean,
  propertyUpsellAmount: number
) => [
  {
    schemaName: 'allHotelProducts',
    messageContent: {
      numOfProducts: 1,
      hotelProducts: [
        {
          productId: hotelId,
        },
      ],
    },
  },
  {
    schemaName: 'allRooms',
    messageContent: {
      productId: hotelId,
      rooms: [
        {
          roomTypeCode,
          propertyUpsell: {
            roomUpsell,
            additionalAmount: propertyUpsellAmount,
          },
          ratePlans: [
            {
              ratePlanCode,
              upsell: {
                rateUpsell,
                additionalAmount,
              },
            },
          ],
        },
      ],
    },
  },
];

export const imageGalleryAlgorithmTrackingSchema = (productId: number, imageId: number, algorithmName: string) => ({
  schemaName: 'allHotelProducts',
  messageContent: {
    numOfProducts: 1,
    hotelProducts: [{ productId, imageId, imageGalleryAlgorithm: { name: algorithmName } }],
  },
});
